import { render, staticRenderFns } from "./Residency.vue?vue&type=template&id=284b6ae8&scoped=true&"
import script from "./Residency.ts?vue&type=script&lang=ts&"
export * from "./Residency.ts?vue&type=script&lang=ts&"
import style0 from "./Residency.vue?vue&type=style&index=0&id=284b6ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b6ae8",
  null
  
)

export default component.exports